"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderMenu = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var uuid_1 = require("uuid");
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var WrappedHeaderMenu = /** @class */ (function (_super) {
    tslib_1.__extends(WrappedHeaderMenu, _super);
    function WrappedHeaderMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WrappedHeaderMenu.prototype.getClassNames = function () {
        return classnames_1.default("gd-header-menu", this.props.className);
    };
    WrappedHeaderMenu.prototype.renderSection = function (items) {
        var _this = this;
        return items.map(function (item) {
            var _a;
            var clickHandler = item.onClick
                ? item.onClick
                : function (event) { return _this.props.onMenuItemClick(item, event); };
            var classNames = classnames_1.default("gd-header-menu-item gd-list-help-menu-item", (_a = {
                    active: item.isActive
                },
                _a[item.className] = !!item.className,
                _a));
            return (react_1.default.createElement("li", { key: item.key },
                react_1.default.createElement("a", { onClick: clickHandler, href: item.href, className: classNames, target: item.target, rel: item.target === "_blank" ? "noreferrer noopener" : undefined },
                    item.iconName ? react_1.default.createElement("i", { className: classnames_1.default(item.iconName, "gd-icon") }) : null,
                    react_1.default.createElement("span", { className: item.className },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: item.key })))));
        });
    };
    WrappedHeaderMenu.prototype.renderSections = function () {
        var _this = this;
        return this.props.sections.map(function (items) {
            return (react_1.default.createElement("ul", { key: "section-" + uuid_1.v4(), className: "gd-header-menu-section gd-header-measure" }, _this.renderSection(items)));
        });
    };
    WrappedHeaderMenu.prototype.render = function () {
        return react_1.default.createElement("div", { className: this.getClassNames() }, this.renderSections());
    };
    WrappedHeaderMenu.defaultProps = {
        className: "",
        onMenuItemClick: identity_1.default,
        sections: [],
    };
    return WrappedHeaderMenu;
}(react_1.PureComponent));
exports.HeaderMenu = react_intl_1.injectIntl(WrappedHeaderMenu);
//# sourceMappingURL=HeaderMenu.js.map